import { render, staticRenderFns } from "./ModeMapperTips.vue?vue&type=template&id=60e80258&"
import script from "./ModeMapperTips.vue?vue&type=script&lang=js&"
export * from "./ModeMapperTips.vue?vue&type=script&lang=js&"
import style0 from "./ModeMapperTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e80258')) {
      api.createRecord('60e80258', component.options)
    } else {
      api.reload('60e80258', component.options)
    }
    module.hot.accept("./ModeMapperTips.vue?vue&type=template&id=60e80258&", function () {
      api.rerender('60e80258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/ModeMapperTips.vue"
export default component.exports